/**
 * Read an env var at runtime.
 *
 * Resolution order:
 *   1. `window.__ENV__` — seeded by a host page before document load
 *   2. `window.__env__` — injected by the container entrypoint at startup
 *   3. `process.env` — baked-in build-time value (useful in dev)
 */
export function getEnv(key: string, fallback = ''): string {
  if (typeof window !== 'undefined') {
    const hostEnv = (window as any).__ENV__;
    if (hostEnv?.[key]) return hostEnv[key];
    const containerEnv = (window as any).__env__;
    if (containerEnv?.[key]) return containerEnv[key];
  }
  if (typeof process !== 'undefined' && process.env?.[key]) return process.env[key];
  return fallback;
}

/**
 * Resolve a service URL to its GraphQL endpoint. Env vars may carry either a
 * bare service URL (env.yaml emits `http://<host>:<port>`) or a full
 * `…/graphql` endpoint (deployed containers) — accept both.
 */
export function toGraphqlEndpoint(url: string): string {
  const base = url.replace(/\/+$/, '');
  return base.endsWith('/graphql') ? base : `${base}/graphql`;
}
